module.exports = __webpack_public_path__ + "img/2.ce97172a.jpg";